import React from "react";
import type { PanelId } from "@/shared/types";

export function TileFlair({
  panelId,
  color,
}: {
  panelId: PanelId;
  color: string;
}) {
  return null;
}
